const config = {
    url: 'https://api.infinitypi.io/'
    // url: 'https://18.162.53.36:8080/'
    // url: 'https://103.6.244.78/'
}

export default config;